/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Box, Button, css, Fade, Grid, Typography } from '@mui/material';
import noMenuIcon from 'assets/noMenuIcon.svg';
import { useTelegramUser } from 'hooks/useTelegramUser';
import { TXT_BACK, TXT_NO_MENU } from 'translations';
import { formatDayLabel } from 'utils/formatDayLabel';
import { ROUTES } from 'utils/routes';

const MenuEmpty: FC<{ dayDate?: string }> = ({ dayDate }) => {
  const { t } = useTranslation();
  const { id: userId } = useTelegramUser();

  return (
    <Fade in>
      <Grid
        container
        direction="column"
        wrap="nowrap"
        justifyContent="center"
        alignItems="center"
        css={css`
          height: calc(100vh - 112px);
        `}
      >
        <Grid item>
          <Grid container direction="column" alignItems="center" spacing={4}>
            <Grid item>
              <Box textAlign="center">
                <img
                  src={noMenuIcon}
                  width={80}
                  height={80}
                  alt="no menu icon"
                />
              </Box>
            </Grid>

            <Grid item>
              {dayDate && (
                <Typography
                  variant="h1"
                  color="primary"
                  textAlign="center"
                  gutterBottom
                >
                  {formatDayLabel(dayDate)}
                </Typography>
              )}
              <Typography
                css={css`
                  width: 225px;
                  text-align: center;
                `}
              >
                {t(TXT_NO_MENU)}
              </Typography>
            </Grid>

            <Grid item>
              <Button
                component={Link}
                to={generatePath(ROUTES.WEEK, { userId: `${userId}` })}
                variant="contained"
                startIcon={<ArrowBackIosNewIcon />}
              >
                {t(TXT_BACK)}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fade>
  );
};

export default MenuEmpty;
